<template>
  <q-page class="container" padding>
    <div class="row col-12">
      <p class="text-h6 text-brand-5 text-weight-bold">Relatório de Status</p>
    </div>

    <q-form ref="myForm">
      <div
        class="row col-12 q-col-gutter-sm text-brand-5 text-weight-bold q-mt-sm"
      >
        <div class="col-md">
          Unidade
          <lista-unidades-select
            v-model="recebeUnidade.unidade"
          ></lista-unidades-select>
        </div>

        <div class="col-md">
          Nome da Ferramenta
          <q-input dense outlined v-model="filtros.nome"></q-input>
        </div>

        <div class="col-md">
          Status Anterior
          <q-select
            dense
            outlined
            v-model="filtros.statusAnterior"
            :options="listaStatusAnterior"
            use-input
            input-debounce="0"
            hide-selected
            fill-input
            option-label="label"
            option-value="value"
          >
          </q-select>
        </div>

        <div class="col-md">
          Status Atual
          <q-select
            dense
            outlined
            v-model="filtros.statusAtual"
            :options="listaStatusAtual"
            use-input
            input-debounce="0"
            hide-selected
            fill-input
            option-label="label"
            option-value="value"
          >
          </q-select>
        </div>
        <div class="col-md col-sm-12 col-xs-12">
          Data Inicial
          <q-input
            dense
            outlined
            placeholder="DD/MM/AAAA"
            v-model="filtros.dataInicial"
            mask="##/##/####"
          >
            <template v-slot:append>
              <q-icon name="event" class="cursor-pointer">
                <q-popup-proxy
                  cover
                  transition-show="scale"
                  transition-hide="scale"
                >
                  <q-date
                    :locale="myLocale"
                    mask="DD/MM/YYYY"
                    v-model="filtros.dataInicial"
                  >
                    <div class="row items-center justify-end">
                      <q-btn
                        v-close-popup
                        label="Fechar"
                        color="primary"
                        flat
                      />
                    </div>
                  </q-date>
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
        </div>
        <div class="col-md col-sm-12 col-xs-12 text-brand-5 text-weight-bold">
          Data Final
          <q-input
            dense
            outlined
            placeholder="DD/MM/AAAA"
            v-model="filtros.dataFinal"
            mask="##/##/####"
          >
            <template v-slot:append>
              <q-icon name="event" class="cursor-pointer">
                <q-popup-proxy
                  cover
                  transition-show="scale"
                  transition-hide="scale"
                >
                  <q-date
                    :locale="myLocale"
                    mask="DD/MM/YYYY"
                    v-model="filtros.dataFinal"
                  >
                    <div class="row items-center justify-end">
                      <q-btn
                        v-close-popup
                        label="Fechar"
                        color="primary"
                        flat
                      />
                    </div>
                  </q-date>
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
        </div>

        <div>
          <p></p>
          <q-btn
            class="q-mt-sm"
            icon="filter_alt"
            no-caps
            color="primary"
            label="Filtrar"
            @click="filtrar()"
          />
        </div>
      </div>
    </q-form>
    <div class="row col-12 q-mt-lg">
      <q-btn
        label="Todas Unidades"
        no-caps
        :color="todasUnidades ? 'negative' : 'primary'"
        :icon="todasUnidades ? 'close' : 'check_circle_outline'"
        @click="todasUnidades = !todasUnidades"
      />
    </div>

    <q-table
      flat
      table-header-class="bg-accent text-width-bold"
      no-data-label
      :loading="loading"
      style="max-height: 50vh"
      id="customers"
      dense
      class="q-mt-lg tabela-tamanho-fixo"
      :rows="movimentacoes"
      :columns="columns"
      :rows-per-page-options="[0]"
      hide-bottom
    >
      <template v-slot:top-right>
        <q-input
          rounded
          outlined
          dense
          debounce="300"
          v-model="filter"
          placeholder="Pesquisar"
        >
          <template v-slot:append>
            <q-icon name="search"></q-icon>
          </template>
        </q-input>
        <q-btn
          class="q-ml-lg"
          color="secondary"
          label="Exportar Todas as Unidades"
          type="submit"
          v-on:click="exportar2"
          icon="file_upload"
          no-caps
        />
        <q-btn
          class="q-ml-lg"
          color="secondary"
          label="Exportar"
          type="submit"
          v-on:click="exportar()"
          icon="file_upload"
          no-caps
        />
      </template>
      <template v-slot:header="props">
        <q-tr :props="props">
          <q-th v-for="col in props.cols" :key="col.name" :props="props">
            {{ col.label }}
          </q-th>
        </q-tr>
      </template>
      <template v-slot:body="props">
        <q-tr :props="props">
          <q-td class="text-left" key="ferramenta_nome" :props="props">
            {{ props.row.ferramenta_nome }}
          </q-td>
          <q-td class="text-left" key="descricao" :props="props">
            {{ props.row.ferramenta_descricao }}
          </q-td>
          <q-td class="text-left" key="descricao" :props="props">
            {{ props.row.ferramenta_patrimonio }}
          </q-td>
          <q-td class="text-left" key="create_at" :props="props">
            {{
              props.row.create_at?.split(" ")[0].split("-").reverse().join("/")
            }}

            {{ props.row.create_at?.split(" ")[1] }}
          </q-td>

          <q-td class="text-left" key="status_anterior" :props="props">
            <div
              :style="
                props.row.status_anterior == 'disponivel'
                  ? 'width: fit-content; background: #e8ffec; padding: 2px 5px;'
                  : props.row.status_anterior == 'manutencao_garantia'
                  ? 'width: fit-content; background: #e6e6e6; padding: 2px 5px;'
                  : props.row.status_anterior == 'uso'
                  ? 'width: fit-content; background: #fefed1; padding: 2px 5px;'
                  : props.row.status_anterior == 'manutencao'
                  ? 'width: fit-content; background: #ffe9e9; padding: 2px 5px;'
                  : props.row.status_anterior == 'em_transito'
                  ? 'width: fit-content; background:  #f8f8f8; padding: 2px 5px;'
                  : props.row.status_anterior == 'removida' ||
                    props.row.status_anterior == 'calibracao'
                  ? 'width: fit-content; background:  #9BA4B5; padding: 2px 5px;'
                  : props.row.status_anterior == 'retorno_em_garantia'
                  ? 'width: fit-content; background:  #9BA4B5; padding: 2px 5px;'
                  : props.row.status_anterior == 'desmobilizada'
                  ? 'width: fit-content; background:  #EDBC5A; padding: 2px 5px;'
                  : props.row.status_anterior == 'reativacao'
                  ? 'width: fit-content; background:  #5178FF; padding: 2px 5px;'
                  : props.row.status_anterior == 'descartada'
                  ? 'width: fit-content; background:  #EBEEFE; padding: 2px 5px;'
                  : props.row.status_anterior == 'sucata'
                  ? 'width: fit-content; background:  #F3E8E0; padding: 2px 5px;'
                  : props.row.status_anterior == 'furto'
                  ? 'width: fit-content; background:  #AB1D22; padding: 2px 5px;'
                  : props.row.status_anterior == 'aguardando_reparo'
                  ? 'width: fit-content; background:  #EDBC5A; padding: 2px 5px;'
                  : props.row.status_anterior == 'aguardando_calibracao'
                  ? 'width: fit-content; background:  #9BA4B5; padding: 2px 5px;'
                  : ''
              "
              class="row col-12 no-wrap align items-center"
            >
              <span
                v-if="props.row.status_anterior == 'disponivel'"
                class="elipse q-mr-sm bg-positive"
              ></span>
              <span
                v-if="props.row.status_anterior == 'uso'"
                class="elipse q-mr-sm bg-warning"
              ></span>
              <span
                v-if="props.row.status_anterior == 'manutencao_garantia'"
                class="elipse q-mr-sm"
                style="background: #424242"
              ></span>
              <span
                v-if="props.row.status_anterior == 'manutencao'"
                class="elipse q-mr-sm bg-red"
              ></span>
              <span
                v-if="props.row.status_anterior == 'em_transito'"
                class="elipse q-mr-sm"
                style="background: #2d3e6e"
              ></span>
              <span
                v-if="
                  props.row.status_anterior == 'removida' ||
                  props.row.status_anterior == 'calibracao'
                "
                class="elipse q-mr-sm"
                style="background: #383737"
              ></span>
              <span
                v-if="props.row.status_anterior == 'retorno_em_garantia'"
                class="elipse q-mr-sm"
                style="background: #383737"
              ></span>
              <span
                v-if="props.row.status_anterior == 'desmobilizada'"
                class="elipse q-mr-sm"
                style="background: #fa9726"
              ></span>
              <span
                v-if="props.row.status_anterior == 'reativacao'"
                class="elipse q-mr-sm"
                style="background: #473fe8"
              ></span>
              <span
                v-if="props.row.status_anterior == 'descartada'"
                class="elipse q-mr-sm"
                style="background: #b0cde8"
              ></span>
              <span
                v-if="props.row.status_anterior == 'sucata'"
                class="elipse q-mr-sm"
                style="background: #736d6a"
              ></span>
              <span
                v-if="props.row.status_anterior == 'furto'"
                class="elipse q-mr-sm"
                style="background: #6b1215"
              ></span>
              <span
                v-if="props.row.status_anterior == 'aguardando_reparo'"
                class="elipse q-mr-sm"
                style="background: #fa9726"
              ></span>
              <span
                v-if="props.row.status_anterior == 'aguardando_calibracao'"
                class="elipse q-mr-sm"
                style="background: #11009e"
              ></span>
              <div
                v-if="props.row.status_anterior == 'disponivel'"
                style="width: fit-content; background: #e8ffec"
                class="text-brand-5 text-bold"
              >
                {{ "Disponível" }}
              </div>
              <div
                v-if="props.row.status_anterior == 'uso'"
                style="width: fit-content; background: #fefed1"
                class="text-brand-5 text-bold"
              >
                {{ "Em Uso" }}
              </div>
              <div
                v-if="props.row.status_anterior == 'manutencao_garantia'"
                style="width: fit-content"
                class="text-brand-5 text-bold"
              >
                {{ "Manutenção Garantia" }}
              </div>
              <div
                v-if="props.row.status_anterior == 'manutencao'"
                style="width: fit-content"
                class="text-red text-bold"
              >
                {{ "Manutenção" }}
              </div>
              <div
                v-if="props.row.status_anterior == 'em_transito'"
                style="width: fit-content; color: #192957"
                class="text-bold"
              >
                {{ "Em Trânsito" }}
              </div>
              <div
                v-if="props.row.status_anterior == 'removida'"
                style="width: fit-content"
                class="text-bold"
              >
                {{ "Removida" }}
              </div>
              <div
                v-if="props.row.status_anterior == 'retorno_em_garantia'"
                style="width: fit-content"
                class="text-bold"
              >
                {{ "Retorno Em Garantia" }}
              </div>
              <div
                v-if="props.row.status_anterior == 'desmobilizada'"
                style="width: fit-content"
                class="text-bold"
              >
                {{ "Desmobilizada" }}
              </div>
              <div
                v-if="props.row.status_anterior == 'reativacao'"
                style="width: fit-content"
                class="text-bold"
              >
                {{ "Reativação" }}
              </div>
              <div
                v-if="props.row.status_anterior == 'descartada'"
                style="width: fit-content"
                class="text-bold"
              >
                {{ "Descartada" }}
              </div>
              <div
                v-if="props.row.status_anterior == 'sucata'"
                style="width: fit-content"
                class="text-bold"
              >
                {{ "Sucata" }}
              </div>
              <div
                v-if="props.row.status_anterior == 'furto'"
                style="width: fit-content"
                class="text-bold"
              >
                {{ "Furto" }}
              </div>
              <div
                v-if="props.row.status_anterior == 'aguardando_reparo'"
                style="width: fit-content"
                class="text-bold"
              >
                {{ "Aguardando Reparo" }}
              </div>
              <div
                v-if="props.row.status_anterior == 'calibracao'"
                style="width: fit-content"
                class="text-bold"
              >
                {{ "Calibração" }}
              </div>
              <div
                v-if="props.row.status_anterior == 'aguardando_calibracao'"
                style="width: fit-content"
                class="text-bold"
              >
                {{ "Aguardando Calibração" }}
              </div>
            </div>
          </q-td>
          <q-td class="text-left" key="status_atual" :props="props">
            <div
              :style="
                props.row.status_atual == 'disponivel'
                  ? 'width: fit-content; background: #e8ffec; padding: 2px 5px;'
                  : props.row.status_atual == 'manutencao_garantia'
                  ? 'width: fit-content; background: #e6e6e6; padding: 2px 5px;'
                  : props.row.status_atual == 'uso'
                  ? 'width: fit-content; background: #fefed1; padding: 2px 5px;'
                  : props.row.status_atual == 'manutencao'
                  ? 'width: fit-content; background: #ffe9e9; padding: 2px 5px;'
                  : props.row.status_atual == 'em_transito'
                  ? 'width: fit-content; background:  #f8f8f8; padding: 2px 5px;'
                  : props.row.status_atual == 'removida' ||
                    props.row.status_atual == 'calibracao'
                  ? 'width: fit-content; background:  #9BA4B5; padding: 2px 5px;'
                  : props.row.status_atual == 'retorno_em_garantia'
                  ? 'width: fit-content; background:  #9BA4B5; padding: 2px 5px;'
                  : props.row.status_atual == 'desmobilizada'
                  ? 'width: fit-content; background:  #EDBC5A; padding: 2px 5px;'
                  : props.row.status_atual == 'reativacao'
                  ? 'width: fit-content; background:  #5178FF; padding: 2px 5px;'
                  : props.row.status_atual == 'descartada'
                  ? 'width: fit-content; background:  #EBEEFE; padding: 2px 5px;'
                  : props.row.status_atual == 'sucata'
                  ? 'width: fit-content; background:  #F3E8E0; padding: 2px 5px;'
                  : props.row.status_atual == 'furto'
                  ? 'width: fit-content; background:  #AB1D22; padding: 2px 5px;'
                  : props.row.status_atual == 'aguardando_reparo'
                  ? 'width: fit-content; background:  #EDBC5A; padding: 2px 5px;'
                  : props.row.status_atual == 'aguardando_calibracao'
                  ? 'width: fit-content; background:  #9BA4B5; padding: 2px 5px;'
                  : ''
              "
              class="row col-12 no-wrap align items-center"
            >
              <span
                v-if="props.row.status_atual == 'disponivel'"
                class="elipse q-mr-sm bg-positive"
              ></span>
              <span
                v-if="props.row.status_atual == 'uso'"
                class="elipse q-mr-sm bg-warning"
              ></span>
              <span
                v-if="props.row.status_atual == 'manutencao_garantia'"
                class="elipse q-mr-sm"
                style="background: #424242"
              ></span>
              <span
                v-if="props.row.status_atual == 'manutencao'"
                class="elipse q-mr-sm bg-red"
              ></span>
              <span
                v-if="props.row.status_atual == 'em_transito'"
                class="elipse q-mr-sm"
                style="background: #2d3e6e"
              ></span>
              <span
                v-if="
                  props.row.status_atual == 'removida' ||
                  props.row.status_atual == 'calibracao'
                "
                class="elipse q-mr-sm"
                style="background: #383737"
              ></span>
              <span
                v-if="props.row.status_atual == 'retorno_em_garantia'"
                class="elipse q-mr-sm"
                style="background: #383737"
              ></span>
              <span
                v-if="props.row.status_atual == 'desmobilizada'"
                class="elipse q-mr-sm"
                style="background: #fa9726"
              ></span>
              <span
                v-if="props.row.status_atual == 'reativacao'"
                class="elipse q-mr-sm"
                style="background: #473fe8"
              ></span>
              <span
                v-if="props.row.status_atual == 'descartada'"
                class="elipse q-mr-sm"
                style="background: #b0cde8"
              ></span>
              <span
                v-if="props.row.status_atual == 'sucata'"
                class="elipse q-mr-sm"
                style="background: #736d6a"
              ></span>
              <span
                v-if="props.row.status_atual == 'furto'"
                class="elipse q-mr-sm"
                style="background: #6b1215"
              ></span>
              <span
                v-if="props.row.status_atual == 'aguardando_reparo'"
                class="elipse q-mr-sm"
                style="background: #fa9726"
              ></span>
              <span
                v-if="props.row.status_atual == 'aguardando_calibracao'"
                class="elipse q-mr-sm"
                style="background: #11009e"
              ></span>
              <div
                v-if="props.row.status_atual == 'disponivel'"
                style="width: fit-content; background: #e8ffec"
                class="text-brand-5 text-bold"
              >
                {{ "Disponível" }}
              </div>
              <div
                v-if="props.row.status_atual == 'uso'"
                style="width: fit-content; background: #fefed1"
                class="text-brand-5 text-bold"
              >
                {{ "Em Uso" }}
              </div>
              <div
                v-if="props.row.status_atual == 'manutencao_garantia'"
                style="width: fit-content"
                class="text-brand-5 text-bold"
              >
                {{ "Manutenção Garantia" }}
              </div>
              <div
                v-if="props.row.status_atual == 'manutencao'"
                style="width: fit-content"
                class="text-red text-bold"
              >
                {{ "Manutenção" }}
              </div>
              <div
                v-if="props.row.status_atual == 'em_transito'"
                style="width: fit-content; color: #192957"
                class="text-bold"
              >
                {{ "Em Trânsito" }}
              </div>
              <div
                v-if="props.row.status_atual == 'removida'"
                style="width: fit-content"
                class="text-bold"
              >
                {{ "Removida" }}
              </div>
              <div
                v-if="props.row.status_atual == 'retorno_em_garantia'"
                style="width: fit-content"
                class="text-bold"
              >
                {{ "Retorno Em Garantia" }}
              </div>
              <div
                v-if="props.row.status_atual == 'desmobilizada'"
                style="width: fit-content"
                class="text-bold"
              >
                {{ "Desmobilizada" }}
              </div>
              <div
                v-if="props.row.status_atual == 'reativacao'"
                style="width: fit-content"
                class="text-bold"
              >
                {{ "Reativação" }}
              </div>
              <div
                v-if="props.row.status_atual == 'descartada'"
                style="width: fit-content"
                class="text-bold"
              >
                {{ "Descartada" }}
              </div>
              <div
                v-if="props.row.status_atual == 'sucata'"
                style="width: fit-content"
                class="text-bold"
              >
                {{ "Sucata" }}
              </div>
              <div
                v-if="props.row.status_atual == 'furto'"
                style="width: fit-content"
                class="text-bold"
              >
                {{ "Furto" }}
              </div>
              <div
                v-if="props.row.status_atual == 'aguardando_reparo'"
                style="width: fit-content"
                class="text-bold"
              >
                {{ "Aguardando Reparo" }}
              </div>
              <div
                v-if="props.row.status_atual == 'calibracao'"
                style="width: fit-content"
                class="text-bold"
              >
                {{ "Calibração" }}
              </div>
              <div
                v-if="props.row.status_atual == 'aguardando_calibracao'"
                style="width: fit-content"
                class="text-bold"
              >
                {{ "Aguardando Calibração" }}
              </div>
            </div>
          </q-td>
          <q-td class="text-left" key="observacao" :props="props">
            {{ props.row.observacao }}
          </q-td>
          <q-td class="text-left" key="usuario_nome" :props="props">{{
            props.row.usuario_nome
          }}</q-td>
          <q-td class="text-left" key="usuario_matricula" :props="props">{{
            props.row.usuario_matricula
          }}</q-td>
          <q-td class="text-left" key="unidade" :props="props">{{
            props.row.nome_unidade
          }}</q-td>
          <q-td class="text-left" key="fornecedor" :props="props">{{
            props.row.fornecedor_nome
          }}</q-td>
        </q-tr>
      </template>
    </q-table>
  </q-page>
</template>

<script>
import { ref, onMounted, watch } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";

export default {
  components: { ListaUnidadesSelect },
  name: "RelatórioMovimentacao",

  setup() {
    const store = useStore();
    const $q = useQuasar();

    const filtros = ref({
      nome: "",
      ferramentaId: "",
      dataInicial: "",
      dataFinal: "",
      statusAnterior: "",
      statusAtual: "",
      ferramenta: "",
    });

    let recebeUnidade = ref({
      unidade: store.state.org.unidadeData.nome,
      id: store.state.org.unidadeData.id,
    });
    const disable = ref(false);

    const movimentacoes = ref([]);
    let todasUnidades = ref(false);
    let loading = ref(false);

    const listaStatusAnterior = ref([
      { label: "Disponível", value: "disponivel" },
      { label: "Manutenção", value: "manutencao" },
      { label: "Manutenção Garantia", value: "manutencao_garantia" },
      { label: "Removida", value: "removida" },
      { label: "Reativação", value: "reativacao" },
      { label: "Desmobilizada", value: "desmobilizada" },
      { label: "Retorno em Garantia", value: "retorno_em_garantia" },
      { label: "Descartada", value: "descartada" },
      { label: "Furto", value: "furto" },
      { label: "Sucata", value: "sucata" },
      { label: "Aguardando Reparo", value: "aguardando_reparo" },
      { label: "Calibração", value: "calibracao" },
      { label: "Aguardando Calibração", value: "aguardando_calibracao" },
    ]);

    const listaStatusAtual = ref([
      { label: "Disponível", value: "disponivel" },
      { label: "Manutenção", value: "manutencao" },
      { label: "Manutenção Garantia", value: "manutencao_garantia" },
      { label: "Removida", value: "removida" },
      { label: "Reativação", value: "reativacao" },
      { label: "Desmobilizada", value: "desmobilizada" },
      { label: "Retorno em Garantia", value: "retorno_em_garantia" },
      { label: "Descartada", value: "descartada" },
      { label: "Furto", value: "furto" },
      { label: "Sucata", value: "sucata" },
      { label: "Aguardando Reparo", value: "aguardando_reparo" },
      { label: "Calibração", value: "calibracao" },
      { label: "Aguardando Calibração", value: "aguardando_calibracao" },
    ]);
    const filter = ref("");

    const columns = [
      {
        name: "ferramenta_nome",
        label: "Código",
        field: "ferramenta_nome",
        align: "left",
        sortable: false,
      },
      {
        name: "descricao",
        label: "Descrição",
        field: "descricao",
        align: "left",
        sortable: false,
      },
      {
        name: "patrimonio",
        label: "Patrimônio",
        field: "ferramenta_patrimonio",
        align: "left",
        sortable: false,
      },
      {
        name: "create_at",
        label: "Data Criação",
        field: "created_at",
        align: "left",
        sortable: true,
      },

      {
        name: "status_anterior",
        label: "Status Anterior",
        field: "status_anterior",
        align: "left",
        sortable: false,
      },
      {
        name: "status_atual",
        label: "Status Atual",
        field: "status_atual",
        align: "left",
        sortable: false,
      },
      {
        name: "observacao",
        label: "Observações",
        field: "observacao",
        align: "left",
        sortable: false,
      },
      {
        name: "usuario_nome",
        label: "Usuário",
        field: "usuario_nome",
        align: "left",
      },
      {
        name: "usuario_matricula",
        label: "Matrícula",
        field: "usuario_matricula",
        align: "left",
      },
      {
        name: "unidade",
        label: "Unidade",
        field: "nome_unidade",
        align: "left",
      },
      {
        name: "fornecedor",
        label: "Fornecedor",
        field: "fornecedor_nome",
        align: "left",
      },
    ];

    const filtrar = async () => {
      await recebeUnidade.value.id;
      try {
        disable.value = true;
        loading.value = true;
        let resposta = await store.dispatch(
          "fer/relatorioMovimentacoesStatus",
          {
            unidadeId: todasUnidades.value ? "" : recebeUnidade.value.id,
            ferramentaId: filtros.value.ferramentaId,
            statusAnterior: filtros.value.statusAnterior?.value,
            statusAtual: filtros.value.statusAtual?.value,
            dataInicial: filtros.value.dataInicial,
            dataFinal: filtros.value.dataFinal,
            ferramenta: filter.value,
          }
        );

        movimentacoes.value = resposta.resposta.data.result.data;

        disable.value = false;
        loading.value = false;
      } catch (error) {
        console.log(error);
      }
    };

    let exportar = async () => {
      await store.dispatch("fer/exportarRelatorioMovimentacoesStatus", {
        unidadeId: recebeUnidade.value.id,
        ferramentaId: filtros.value.ferramentaId,
        statusAnterior: filtros.value.statusAnterior,
        statusAtual: filtros.value.statusAtual,
        dataInicial: filtros.value.dataInicial,
        dataFinal: filtros.value.dataFinal,
      });
      mensagem(
        "Seu relatório de MOVIMENTAÇÕES está sendo processado, você receberá um link pra download no seu email assim que ele estiver pronto!"
      );
    };

    let exportar2 = async () => {
      await store.dispatch("fer/exportarRelatorioMovimentacoesStatus", {
        unidadeId: "",
        ferramentaId: filtros.value.ferramentaId,
        statusAnterior: filtros.value.statusAnterior,
        statusAtual: filtros.value.statusAtual,
        dataInicial: filtros.value.dataInicial,
        dataFinal: filtros.value.dataFinal,
      });
      mensagem(
        "Seu relatório de MOVIMENTAÇÕES está sendo processado, você receberá um link pra download no seu email assim que ele estiver pronto!"
      );
    };

    let mensagem = (mensagem) => {
      $q.notify({
        message: mensagem,
        color: "positive",
        actions: [
          {
            label: "Fechar",
            color: "white",
            handler: () => {
              /* ... */
            },
          },
        ],
      });
    };

    onMounted(filtrar);

    const getUnidade = () => {
      if (
        localStorage.unidade &&
        localStorage.unidade != null &&
        localStorage.unidade != "null"
      ) {
        let getunidade = localStorage.getItem("unidade");
        recebeUnidade.value.unidade = JSON.parse(getunidade);
      }
    };

    onMounted(getUnidade);

    watch(
      () => store.state.org.unidadeData.id,
      () => {
        if (store.state.org.unidadeData == null) {
          return;
        }
        recebeUnidade.value.unidade = store.state.org.unidadeData;
        recebeUnidade.value.id = store.state.org.unidadeData.id;
        filtrar();
      }
    );

    watch(
      () => todasUnidades.value,
      () => {
        filtrar();
      }
    );

    watch(
      () => filter.value,
      () => {
        filtrar();
      }
    );

    return {
      filter,
      filtros,
      columns,
      movimentacoes,
      listaStatusAnterior,
      listaStatusAtual,
      filtrar,
      exportar,
      exportar2,
      disable,
      recebeUnidade,
      todasUnidades,
      myLocale: {
        /* starting with Sunday */
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
      loading,
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
.elipse {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}
tbody tr td {
  white-space: pre-wrap;
}
.q-table__top,
thead tr:first-child th {
  background-color: #eef3fe;
}

thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:first-child th {
  top: 0;
}

.q-table--loading thead tr:last-child th {
  top: 48px;
}
.my-sticky-dynamic {
  max-height: 400px;
}
thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:last-child th {
  top: 48px;
}
thead tr:first-child th {
  top: 0;
}
</style>
